import * as React from 'react'
import { SVGProps } from 'react'
const SvgAverageFull = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 129 129' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#average_full_svg__a)'>
      <circle opacity={0.9} cx={64.4} cy={64.294} r={64} fill='#69ae97' />
      <path
        d='M46.666 59.936 31.552 83.172c-1.37 2.107.12 4.894 2.633 4.894h60.074c2.582 0 4.077-2.913 2.569-5.008-6.887-9.572-21.402-29.766-23.312-32.567v-5.43h13.21a1.267 1.267 0 0 0 1.033-1.999l-2.787-4.93 2.787-4.929c.595-.839-.005-2-1.033-2H72.8v-.876c0-.7-.567-1.267-1.266-1.267h-.181c-.7 0-1.267.568-1.267 1.267v20.164L57.514 68.778l-5.51-8.797c-1.228-1.96-4.077-1.985-5.338-.045Z'
        fill='#DBE1DF'
      />
    </g>
    <defs>
      <clipPath id='average_full_svg__a'>
        <path fill='#fff' transform='translate(.4 .294)' d='M0 0h128v128H0z' />
      </clipPath>
    </defs>
  </svg>
)
export default SvgAverageFull
